export default __webpack_public_path__ + "static/media/short.1f94a0c2.svg";